import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Image from 'atoms/Image';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { isCateringDisposition, redirectToCateringPage, redirectToMenuPage } from 'common/utilities/utils';

const { EmptyCartImage } = IMAGE_PATH;
const { EMPTY_CART } = CART_PAGE_CONSTANTS;
const { PLACEHOLDER_TEXT, START_ORDER } = EMPTY_CART;

function EmptyCartPlaceholder(props) {
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;

  const history = useHistory();
  const onStartOrderClick = () => {
    if (userParams?.localized) {
      if (isCateringDisposition(props?.dispositionData?.type)) {
        redirectToCateringPage({ history });
      } else {
        redirectToMenuPage({ history });
      }
    } else {
      userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    }
  };

  const { title = PLACEHOLDER_TEXT, onBtnClickHandler = onStartOrderClick, btnText = START_ORDER } = props;

  return (
    <div className='cart-empty-placeholder cart-empty-root '>
      <div className='cart-empty-placeholder-view'>
        <span className='cart-empty-placeholder-text'>{translateWithI18Next(title)}</span>
        <ContainedButton
          className='recommended-empty-cart-start-order-button'
          variant={ButtonType.primary}
          aria-label={translateWithI18Next(btnText)}
          onClickHandler={onBtnClickHandler}
          id='startOrderItemButton'
          type='submit'
          data-testid='empty-cart-start-order-button'
        >
          <span>{translateWithI18Next(btnText)}</span>
        </ContainedButton>
      </div>
      <Image className='cart-empty-img' srcFile={EmptyCartImage} altText='' />
    </div>
  );
}

export default EmptyCartPlaceholder;
